import React from "react";
import {useQuery} from "@apollo/client";
import {Container, Tab, Tabs} from "react-bootstrap";
import {getClientById} from "./ClientQueries";
import PageTitle from "../../../layout/PageTitle";
import {NavLink, useParams} from "react-router-dom";
import ClientMenusList from "./ClientMenusList";
import {BackButton} from "../../../helpers/ButtonHelper";
import Avatar from "../../shared/Avatar";
import Badge from "react-bootstrap/Badge";
import ClientCommentsList from "./ClientCommentsList";
import ClientRatingsList from "./ClientRatingsList";
import ClientDiseasesList from "./ClientDiseasesList";
import ClientMedicationsList from "./ClientMedicationsList";
import ClientAllergiesList from "./ClientAllergiesList";
import ClientBadIngredientsList from "./ClientBadIngredientsList";

const ClientDetails = () => {
  const params = useParams()
  let client = {fName: '', lName: '', email: '', phone: '', full_name: '', menus: []}
  const {loading, data} = useQuery(getClientById, {variables: {id: params.id}})

  if (!client.id && !loading && data)
    client = data.client

  return (
    <>
      <Container className="mb-4">
        <PageTitle title="Detalii client" buttons={<BackButton to='/clients' showText={true} text='Inapoi la lista'/>}/>
        <div className="card mb-3 shadow">
          <div className="row g-0">
            <div className="col-md-4 text-center py-3">
              <Avatar src={client.avatar} className="img-fluid rounded-start" alt="..."></Avatar>

            </div>
            <div className="col-md-8">
              <div className="card-body">
                <h4 className="card-title">{client.fullName}</h4>
                <p className="card-text m-1">{client.phone}</p>
                <p className="card-text m-1">{client.email}</p>
                <p className="card-text m-1">Parola: 12345asdf</p>
                {/*<p className="card-text m-1">*/}
                {/*  Statusul invitatiei: {client.status === "invited" ? 'Invitat' : 'Invitatie acceptata'}*/}
                {/*</p>*/}
                <p>
                  {client.measurementsCount > 0 &&
                    <NavLink to={`/clients/${client.id}/measurements`}>
                      Masuratori
                      <Badge pill bg="info" className='ms-2'>{client.measurementsCount}</Badge>
                    </NavLink>
                  }
                </p>
                <p>
                  Comentarii
                  <Badge pill bg="danger" className='ms-2'>{client.commentsCount}</Badge>
                </p>
                <p>
                  Ratinguri
                  <Badge pill bg="danger" className='ms-2'>{client.ratingsCount}</Badge>
                </p>
              </div>
            </div>
          </div>
        </div>
        {!loading &&
          <>
            <div className="mb-4">
              <Tabs>
                <Tab title='Meniuri' eventKey='menuItems'>
                  <div className='border border-top-0 p-3 rounded-bottom shadow'>
                    <ClientMenusList client={client}/>
                  </div>
                </Tab>

                <Tab title='Comentarii' eventKey='commentItems'>
                  <div className='border border-top-0 p-3 rounded-bottom shadow'>
                    <ClientCommentsList client={client}/>
                  </div>
                </Tab>

                <Tab title='Ratinguri' eventKey='ratingsItems'>
                  <div className='border border-top-0 p-3 rounded-bottom shadow'>
                    <ClientRatingsList client={client}/>
                  </div>
                </Tab>
              </Tabs>
            </div>
            <div>
              <Tabs>
                <Tab title='Afectiuni' eventKey='diseasesItems'>
                  <div className='border border-top-0 p-3 rounded-bottom shadow'>
                    <ClientDiseasesList client={client}/>
                  </div>
                </Tab>

                <Tab title='Medicamente' eventKey='medicationsItems'>
                  <div className='border border-top-0 p-3 rounded-bottom shadow'>
                    <ClientMedicationsList client={client}/>
                  </div>
                </Tab>

                <Tab title='Alergii' eventKey='allergiesItems'>
                  <div className='border border-top-0 p-3 rounded-bottom shadow'>
                    <ClientAllergiesList client={client}/>
                  </div>
                </Tab>
                <Tab title='Nu pot manca' eventKey='badIngredientsItems'>
                  <div className='border border-top-0 p-3 rounded-bottom shadow'>
                    <ClientBadIngredientsList client={client}/>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </>
        }
      </Container>
    </>
  )
};

export default ClientDetails;
